$(document).mouseup(function(e) 
{
    var container = $("#menu-drawer");
  	var container_2 = $(".menu-drawer-container");
  

    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        if (!container_2.is(e.target) && container_2.has(e.target).length === 0) 
    	{
          
            	
              $(".menu-drawer-container").removeClass("menu-opening");
              $('body').attr('class', 'gradient');
              $(".menu-drawer-container").removeAttr("open");
          	  $(".menu-drawer-container .summary").attr("aria-expanded","false");
              $(".header__icon--menu.header__icon--summary").attr("aria-expanded","false");
          	  //$("summary.header__icon.header__icon--menu").trigger("click");
				
          	
          
        }
    }
});


$(document).ready(function() {
  var modals = [];
  $('a[data-fancybox="images"]').each(function(){
  	var modalID = $(this).attr('data-modal');
    if(!$.inArray(modalID, modals) != -1) {
      if(modalID!="")
      {
        modals.push(modalID);
      }
    }
  });
  if(modals.length > 0)
  {
  
  	var unique = modals.filter(function(itm, i, modals) {
    	return i == modals.indexOf(itm);
	});
    
    for(var m=0; m<unique.length; m++)
    {
      $("a[data-modal='"+unique[m]+"']").fancybox({
      	hash: false,
        toolbar:true,
        hideOnContentClick : true
      });
    }
    
  }
  
  $("span.product__media-icon.motion-reduce").click(function(){
  
    $(this).parent().find("a").trigger("click");
  
  });
  

});
	
